var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSignalLive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "current",
    stroke: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3642 4.22179C18.7547 3.83126 19.3879 3.83126 19.7784 4.22179C21.7679 6.21131 23.0002 8.96268 23.0002 11.9999C23.0002 15.0373 21.7679 17.7886 19.7784 19.7782C19.3879 20.1687 18.7547 20.1687 18.3642 19.7782C17.9737 19.3876 17.9737 18.7545 18.3642 18.3639C19.994 16.7342 21.0002 14.4855 21.0002 11.9999C21.0002 9.51442 19.994 7.26579 18.3642 5.636C17.9737 5.24547 17.9737 4.61231 18.3642 4.22179Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.63603 4.22178C6.02656 4.61231 6.02656 5.24547 5.63604 5.636C4.00626 7.26579 3 9.51442 3 11.9999C3 14.4855 4.00627 16.7342 5.63604 18.3639C6.02656 18.7545 6.02656 19.3876 5.63603 19.7782C5.24551 20.1687 4.61234 20.1687 4.22182 19.7782C2.23231 17.7886 1 15.0373 1 11.9999C1 8.96268 2.23231 6.21131 4.22182 4.22179C4.61234 3.83126 5.24551 3.83126 5.63603 4.22178Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25736 6.34313C8.64788 6.73365 8.64788 7.36681 8.25736 7.75734C7.17048 8.84422 6.5 10.3428 6.5 12C6.5 13.6571 7.17048 15.1557 8.25736 16.2426C8.64788 16.6332 8.64788 17.2663 8.25736 17.6568C7.86683 18.0474 7.23367 18.0474 6.84314 17.6568C5.39652 16.2102 4.5 14.2088 4.5 12C4.5 9.79112 5.39652 7.78975 6.84314 6.34313C7.23367 5.9526 7.86683 5.9526 8.25736 6.34313Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7426 6.34313C16.1331 5.9526 16.7663 5.9526 17.1568 6.34313C18.6034 7.78975 19.5 9.79112 19.5 12C19.5 14.2088 18.6034 16.2102 17.1568 17.6568C16.7663 18.0474 16.1331 18.0474 15.7426 17.6568C15.3521 17.2663 15.3521 16.6332 15.7426 16.2426C16.8295 15.1557 17.5 13.6571 17.5 12C17.5 10.3428 16.8295 8.84422 15.7426 7.75734C15.3521 7.36681 15.3521 6.73365 15.7426 6.34313Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.4999C12.8284 13.4999 13.5 12.8284 13.5 11.9999C13.5 11.1715 12.8284 10.4999 12 10.4999C11.1716 10.4999 10.5 11.1715 10.5 11.9999C10.5 12.8284 11.1716 13.4999 12 13.4999Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignalLive);
export default __webpack_public_path__ + "static/media/signal-live.51a8044d38ed7879304dece5ecc0df89.svg";
export { ForwardRef as ReactComponent };